import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const promoLinkCodeSchema = z
  .string()
  .trim()
  .regex(/^[A-Za-z0-9_-]{3,50}$/)
  .transform((code) => code.toUpperCase());

export const claimPromoLinkSchema = z.object({
  code: promoLinkCodeSchema,
});

export const promoLinkClaimResultSchema = z.object({
  status: z.enum(["claimed", "already_claimed", "expired", "invalid"]),
  expiresAt: z.coerce.date().optional(),
});

export type PromoLinkClaimResult = z.infer<typeof promoLinkClaimResultSchema>;

export class ClaimPromoLinkDto extends createZodDto(claimPromoLinkSchema) {}
